import { useCallback } from "react";
import { toast } from "sonner";
import { ESet } from "../models/ESet";
import { getFeelingDisplay, getFeelingIcon, SetFeedback } from "../models/SetFeedback";
import SetFeedbackForm from "./SetFeedbackForm";
import { Button } from "./ui/button";
import WeightInput from "./WeightInput";

type Props = {
  n: number;
  reps: number;
  weightLbs: number | null;
  isDone: boolean;
  exerciseName: string;
  exerciseId: string;
  onRemove?: () => void;
  onChange?: (patch: Partial<ESet>) => void;
  feedback?: SetFeedback;
}

function SetRow({
  n,
  reps,
  weightLbs,
  isDone,
  feedback,
  onChange,
  onRemove,
  exerciseName,
  exerciseId
}: Props) {

  const handleToggleDone = useCallback(() => {
    if (!isDone) {
      const currentSet: ESet = { reps: reps ?? 1, weightLbs, done: isDone, feedback }
      toast.custom((id) => {
        return <SetFeedbackForm eSet={currentSet} toastId={id} onFeedbackChange={(feedback) => {
          onChange?.({ feedback })
        }} exerciseName={exerciseName} exerciseId={exerciseId} setNumber={n} />
      })
    }
    onChange?.({ done: !isDone })
  }, [isDone, onChange, reps, weightLbs, feedback, exerciseName, n, exerciseId])
  return (
    <div className={`w-full p-2 rounded-md ${isDone ? 'bg-complete' : ''}`}>
      <div className={`flex items-center justify-between w-full p-2 rounded-md`} >
        {n && <span className="text-muted-foreground text-sm">{n}.</span>}
        <label>
          <span className="sr-only">Reps</span>
          <input
            type="number"
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                e.currentTarget.blur();
              }
            }}
            onFocus={(e) => {
              e.target.select();
            }} onChange={(e) => {
              onChange?.({ reps: parseInt(e.target.value, 10) })
            }} value={reps} className="w-12 text-center border-dashed border-b-2 border-muted-foreground" />
        </label>
        <span className="text-muted-foreground text-sm">x</span>
        <WeightInput isDone={isDone} weightLbs={weightLbs} onChange={(w) => {
          onChange?.({ weightLbs: w })
        }} />
        <Button className={`p-3 ${isDone ? 'bg-complete-foreground' : ''}`} variant={isDone ? "default" : "outline"} onClick={handleToggleDone}>
          ✓
        </Button>
        <Button className="p-3 text-muted-foreground" variant="secondary" onClick={() => {
          onRemove?.()
        }}>X</Button>
      </div>
      {/* TODO: make this a component */}
      {feedback && <span className="text-xs flex flex-row items-center gap-1">{getFeelingIcon(feedback?.feeling)} {getFeelingDisplay(feedback.feeling)} {feedback.injured ? <span className="text-red-500 font-bold"> - Injured</span> : ''}{feedback.comment ? <span className="italic">&middot; {feedback.comment}</span> : ""}</span>}
    </div>
  )
}

export default SetRow
